import React from "react";
import { Grid, Typography, Button } from "@material-ui/core";
import Styles from "../../../Styles.module.css";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import clsx from "clsx";
import { isMobileDevice } from "../../../utils/AppUtils";

function FundHomeSteps({ steps, xlUp }) {
  return (
    <React.Fragment>
      {steps.map((data, index) => {
        return (
          <Grid
            item
            xs={2}
            container
            key={index}
            justifyContent="center"
            style={{
              height: isMobileDevice() ? "100%" : "90%",
              minWidth: isMobileDevice() && "40%",
            }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{
                height: isMobileDevice() ? "40%" : xlUp ? "42%" : "25%",
              }}
            >
              <img
                src={data.image}
                style={{ width: isMobileDevice() ? "70%" : "85%" }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                height: xlUp || isMobileDevice() ? "20%" : "10%",
                textAlign: "center",
              }}
            >
              <Typography
                className={Styles.navyBlueColor}
                style={{ fontSize: xlUp ? 12 : 8 }}
              >
                {data.description}
              </Typography>
            </Grid>
            <Grid
              container
              item
              xs={4}
              justifyContent="center"
              alignItems="center"
              alignContent="center"
              style={{
                backgroundColor: "#F5F6F8",
                height: isMobileDevice() ? 40 : xlUp ? 48 : 32,
                width: isMobileDevice() ? 40 : xlUp ? 42 : 32,
                borderRadius: "50%",
                textAlign: "center",
              }}
            >
              <Typography
                className={clsx(Styles.navyBlueColor, Styles.font14)}
                style={{ fontWeight: 500 }}
              >
                {index + 1}
              </Typography>
            </Grid>
          </Grid>
        );
      })}
    </React.Fragment>
  );
}

export default function FundHomeJourney({
  xlUp,
  setShowFundHomeJourney,
  setShowFullJourney,
}) {
  const steps = [
    {
      description: "Offer accepted!",
      image: "/images/fund-home-step1.svg",
    },
    {
      description: "Complete property inspection",
      image: "/images/fund-home-step2.svg",
    },
    {
      description: "Order property appraisal",
      image: "/images/fund-home-step3.svg",
    },
    {
      description: "Shop for homeowners Insurance",
      image: "/images/fund-home-step4.svg",
    },
    {
      description: "Obtain final approval for home mortgage",
      image: "/images/fund-home-step5.svg",
    },
    {
      description: "Waive conditions on purchase and sale agreement",
      image: "/images/fund-home-step6.svg",
    },
  ];
  return (
    <Grid
      container
      spacing={!isMobileDevice() && 4}
      style={{
        // height: xlUp ? "20.75rem" : "18.5rem"
        height: isMobileDevice() ? 251 : xlUp ? "18.5rem" : 282,
      }}
    >
      <Grid
        item
        xs={12}
        style={{
          padding: isMobileDevice() ? 0 : "10px 0px 0px 20px",
          height: isMobileDevice() ? 0 : xlUp ? "12%" : "15%",
        }}
      >
        <Button
          startIcon={<ArrowBackIosIcon />}
          style={{
            textTransform: "capitalize",
            color: "#66D7D1",
          }}
          onClick={() => {
            setShowFundHomeJourney(false);
            setShowFullJourney(true);
          }}
        >
          Fund Your Home
        </Button>
      </Grid>
      {isMobileDevice() ? (
        <Grid
          container
          item
          xs={12}
          style={
            isMobileDevice()
              ? {
                  display: "flex",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                }
              : {}
          }
        >
          <FundHomeSteps steps={steps} xlUp={xlUp} />
        </Grid>
      ) : (
        <FundHomeSteps steps={steps} xlUp={xlUp} />
      )}
    </Grid>
  );
}
